<template>
  <Layout style="height: 100%" class="main">
        <header-bar />
			  <Content class="main-content-con">
				<Layout class="main-layout-con">
				  <Content class="content-wrapper">
					<router-view style="min-height: 600px" />
				  </Content>
				</Layout>
			  </Content>
		<footer-bar />
  </Layout>
</template>
<script>
import headerBar from "./components/header-bar/index.vue";
import footerBar from "./components/footer-bar/index.vue";
export default {
  name: "Main",
    components: {
      headerBar,
	  footerBar
    },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
  methods: {
   
  },
  watch: {
   
  },
  mounted() {
   
  },
};
</script>
<style>

</style>
